import React, { Component } from 'react';
import { Col, message, Modal, Row, Table } from 'antd';
import { connect } from 'react-redux';

import { queryAllotApplyContract, queryContractList } from '@api/xxcrm/contract';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    const { record } = this.props;
    this.loadDate(record.number, record.type);
  }

  findContractType = id => {
    const { list } = this.props;
    const type = list.map(item => {
      if (parseInt(item.value, 10) === parseInt(id, 10)) {
        return item.key;
      }
      return type;
    });
    for (let i = 0; i < list.length; i++) {
      if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
        return list[i].key;
      }
    }
    return type;
  };

  loadDate = (limit, type) => {
    const params = {};
    const context = this;
    params.start = 0;
    params.type = type;
    params.status = 0;
    params.limit = this.props.record.number;
    queryContractList(params).then(res => {
      const selectedRowKeys = [];
      if (res.statusCode === 200) {
        res.data.map(item => {
          item.type = this.findContractType(item.type);
          selectedRowKeys.push(item.uuid);
          return selectedRowKeys;
        });
        context.setState({
          data: res.data,
          total: res.totalSize,
          selectedRowKeys,
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        key: 'no',
        width: 100,
      },
      {
        title: '合同类型',
        dataIndex: 'type',
        key: 'type',
        width: 100,
      },
    ];
  };

  onSelectChange = selectedRowKeys => {
    this.setState({
      selectedRowKeys,
    });
  };

  submit = () => {
    const { record, cancel, loadDate } = this.props;
    const data = {};
    data.uuid = record.uuid;
    data.contractUuids = this.state.selectedRowKeys;
    if (data.contractUuids < 1) {
      message.error('暂时没有可分配的合同！');
      return;
    }
    queryAllotApplyContract(data).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        cancel();
        loadDate();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel, record } = this.props;
    const { data } = this.state;
    const type = this.findContractType(record.type);
    return (
      <Modal
        title="分配合同"
        width={450}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Row>
          <Col span={7}>
            <p>
              申请人:
              {record.userName}
            </p>
          </Col>
          <Col span={7}>
            <p>
              申请份数:
              {record.number}
            </p>
          </Col>
          <Col span={10}>
            <p>
              合同类型:
              {type}
            </p>
          </Col>
        </Row>
        <Row>
          <p style={{ padding: '20px 0 5px 0' }}>待分配合同信息</p>
          <Table
            columns={this.columns()}
            dataSource={data}
            pagination={false}
            bordered
            rowKey="uuid"
            scroll={{ y: 300 }}
          />
        </Row>
      </Modal>
    );
  }
}

export default connect(state => ({ list: state.contract_type }))(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalAllot2.js